import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../WorkoutTemplateBuilder'
import { Switch } from '@headlessui/react'

import { PlusCircleIcon, MinusCircleIcon } from '@heroicons/react/24/outline'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function ContinuousOverrideComponent({ phaseIndex, exercise, exerciseIndex }) {
    const { mode, mutateExercise } = useContext(WorkoutTemplateBuilderContext)

    switch (mode) {
        // Edit mode
        case 'edit':
            return (
                <div className="h-6 flex items-center gap-x-4 px-4">
                    {/* Toggle */}
                    <Switch
                        checked={exercise.continuousOverride}
                        onChange={() => mutateExercise('toggle-continuous-override', phaseIndex, exerciseIndex)}
                        className={classNames(
                            exercise.continuousOverride ? 'bg-orange-600' : 'bg-gray-200',
                            '-ml-4 scale-50 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2'
                        )}
                    >
                        <span className="sr-only">Use setting</span>

                        <span
                            aria-hidden="true"
                            className={classNames(
                                exercise.continuousOverride ? 'translate-x-5' : 'translate-x-0',
                                'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                            )}
                        />
                    </Switch>

                    {/* Title Text */}
                    <p className="-ml-4 text-xs">Continuous override</p>

                    {/* Info Text */}
                    <p className="text-xs text-gray-500 flex-grow">Set a weight</p>

                    {/* Continuous override weight changer */}
                    {exercise.continuousOverride && (
                        <div className="flex items-center text-center gap-x-2 text-xs">
                            <p>Weight:</p>

                            <button onClick={() => mutateExercise('subtract-continuous-override-weight', phaseIndex, exerciseIndex)}>
                                <MinusCircleIcon className="h-4 text-stone-500 hover:text-stone-400" />
                            </button>

                            <p>{exercise.continuousOverrideWeight} lbs</p>

                            <button onClick={() => mutateExercise('add-continuous-override-weight', phaseIndex, exerciseIndex)}>
                                <PlusCircleIcon className="h-4 text-stone-500 hover:text-stone-400" />
                            </button>
                        </div>
                    )}
                </div>
            )

        // View mode
        case 'view':
            if (exercise.continuousOverride) {
                return (
                    <div className="h-6 flex items-center px-2 border-t border-stone-400 text-xs">
                        <p className="flex-grow">Continuous Override</p>
                        <p>{exercise.continuousOverrideWeight} lbs</p>
                    </div>
                )
            }

            break

        // Error message
        default:
            console.error(mode + ' is not a valid mode!!')
    }
}
